import React, {useEffect, useRef, useState} from 'react';
import MainLayout from "../../layouts/main";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {AppRoutes, SearchTypes} from "../../utils/constants";
import {Link} from "react-router-dom";
import {useHomepageService} from "../../services/homepage-service";
import {useGlobalNotificationMessage} from "../../context/message";
import HomepageBannerCell from "../../components/homepage-banner-cell";
import {ClickableSlider} from "../../components/clickable-slider";
import TopTrainersListModal from "../../components/top-trainers-list-modal";
import StarRating from "../../components/star-rating";
import LocationFilter from "../../components/location-filter";
import {getSearchFilter} from "../../modules/auth-persistor";
import EventCell from "../../components/event-cell";
import CategoryCell from "../../components/category-cell";
import ActiveFilters from "../../components/active-filters";
import {useAuth} from "../../context/auth";

//redeploy
export default function Discover () {
  const [upcomingClasses, setUpcomingClasses] = useState([]);
  const [trendingTemplates, setTrendingTemplates] = useState([]);
  const [topTrainers, setTopTrainers] = useState(false);
  const [banners, setBanners] = useState(false);
  const {addErrorMessage} = useGlobalNotificationMessage();
  const topTrainersListModal = useRef();

  const homepageService = useHomepageService();
  const auth = useAuth();

  const bannerSliderSettings = {
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const topTrainersSliderSettings = {
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const upcomingClassesSliderSettings = {
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  useEffect(() => {
    document.addEventListener('swipe', function (event, slick, direction) {
      if (event?.target?.hasClass('slick-slider')) {
        event.stopPropagation();
      }
    });

    let promises = [
      homepageService.getBanners(),
      homepageService.getTopTrainers(),
    ];

    let searchFilter = getSearchFilter();
    if (searchFilter){
      promises.push(homepageService.discoverClassesByCategories({lat: searchFilter.lat, lon: searchFilter.lon, radius: searchFilter.radius}));
    }

    Promise.all(promises).then(async ([banners = [], trainers = [], events = []]) => {
      // let _events = events.map((e)=> {
      //   if (e.events.length>0){
      //     e.events = [...e.events.filter((ee) => {
      //       return (dayjs(ee.datetime, 'x').tz(ee.timezone).isAfter(currentDate));
      //     })];
      //   }
      //   return e;
      // });

      setBanners(banners || []);
      setTopTrainers(trainers || []);
      setUpcomingClasses(events || []);

      //attempt to make dynamic categories... synced to hardcoded as app has.
      // let catIds = [];
      // let cats = [];
      // if (events.length>0){
      //   events.map((e)=> {
      //     e.course.categories.map((ec)=> {
      //       if (!catIds.includes(ec.id) && catIds.length<6){
      //         catIds.push(ec.id);
      //         cats.push(ec);
      //       }
      //     });
      //   });
      //   events = events.filter((e)=> {
      //     let found = false;
      //     let dayjs = HelperService.getDayjs();
      //     let now = dayjs();
      //     if (e.events.length>0){
      //      e.events.map((_e) => {
      //         if (dayjs(_e.datetime, 'x').tz(_e.timezone))<now){
      //           return
      //         }
      //      })
      //     }
      //     return found;
      //   });
      // }
      setTrendingTemplates(JSON.parse(`[
    {
      "id": "45",
      "name": "Dance Fitness",
      "type": "GROUP_TRAINING",
      "cover": "https://s3.amazonaws.com/sweatnow-prod/categories/743593922241ca7a763f4dbfca5c845f43a43c79962bfda0ea71a44911715bb3.jpg",
      "liked": false,
      "classes": 9
    },
    {
      "id": "10",
      "name": "Yoga",
      "type": "GROUP_TRAINING",
      "cover": "https://sweatnow-prod.s3.amazonaws.com/categories/7b8009fb840b512ce7791c054dae893ae48baa8235061d497cf1a577428ba2a9.jpg",
      "liked": false,
      "classes": 40
    },
    {
      "id": "5",
      "name": "Indoor Cycling",
      "type": "GROUP_TRAINING",
      "cover": "https://sweatnow-prod.s3.amazonaws.com/categories/5b63412ac7ef140755e90d951888d2b1f70f736dd498b80ab7d4b39facde23de.jpg",
      "liked": false,
      "classes": 43
    },
    {
      "id": "30",
      "name": "High Intensity Training",
      "type": "GROUP_TRAINING",
      "cover": "https://s3.amazonaws.com/sweatnow-prod/categories/f37bfcdecfb21f33b532626e756872da401789e473bdf31e4eda8edb6faa7b18.jpg",
      "liked": false,
      "classes": 5
    },
    {
      "id": "2",
      "name": "Personal Training and Lessons",
      "type": "PERSONAL_TRAINING",
      "cover": "https://s3.amazonaws.com/sweatnow-prod/categories/38b8ef24fcd5d9f70ae979042bec34a3a1e105d57b6eac8523845e75dbca23c6.jpg",
      "liked": false,
      "classes": 4
    },
    {
      "id": "19",
      "name": "Fundraisers",
      "type": "GROUP_TRAINING",
      "cover": "https://s3.amazonaws.com/sweatnow-prod/categories/6efc9ec89cb29f80834c9bf3b1fa06d6f8cce7d79dc2372493ead50b27e091d6.jpg",
      "liked": true,
      "classes": 0
    }
  ]`));

    }).catch(error => {
      HelperService.handleApiErrors(error, addErrorMessage);
    });
  // eslint-disable-next-line
  }, []);

  const onFilterChanged = (filter) => {
    HelperService.log(filter);
    //get latest events based on filter
    homepageService.discoverClassesByCategories(filter).then((res)=>{
      setUpcomingClasses(res || []);
    })
  }

  const topTrainersListCallback = (t) => {
    setTopTrainers([...HelperService.addOrReplaceItemInList(topTrainers, t)]);
  }

  const TopTrainerCell = function ({trainer, ...props}) {
    return ( <Link to={`${AppRoutes.trainers.path}/${trainer?.id}`} className="clickable router-link">
      <div className="card px-3 py-4 mb-4 border-0 hover-cell-effect rounded-3">
        <div className="d-flex flex-row gap-3">
          <div className="rounded-circle bg-cover flex-shrink-0"
               style={{backgroundImage: `url(${trainer.photo})`, width: '90px', height: '90px'}}></div>
          <div className="px-2 w-100" style={{minWidth: 0}}>
            <h6>{trainer.name}</h6>
            <StarRating rating={trainer.rating} count={trainer.ratingsCount} showCount={true} />
            <div className="text-secondary fs-7 text-fadeout">{trainer.categories}</div>
          </div>
        </div>
        <div className="fst-italic mt-2 fs-7"><q lang="en">{trainer.review}</q></div>
      </div>
    </Link>);
  }

  return (
      <>
        <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding-first">
          <div className={"container"}>
            <div className={"row"}>
              <div className={"col-sm-12 col-md-12 mb-2 d-flex justify-content-center gap-2"}>
                <div>
                  <LocationFilter onChange={(filter) => onFilterChanged(filter)}/>
                </div>
                <Link to={AppRoutes.searchEvents.path}>
                  <button className="btn btn-light clickable">
                    <span className="mdi mdi-magnify"></span>
                  </button>
                </Link>
              </div>
              <div className={"col-sm-12 col-md-12 mb-2 d-flex justify-content-center gap-2"}>
                <div>
                  <ActiveFilters onChange={(filter) => onFilterChanged(filter)} />
                </div>
              </div>
            </div>
          </div>
        </Section>

        {auth.showFitproNotice===true && <Section animation={HelperService.getRandomAnimation()} className="position-relative mb-3">
          <div className={"container"}>
            <div className={"row"}>
              <div className={"col-sm-12 col-md-12 d-flex justify-content-center gap-2"}>
                <div className="rounded-3 bg-info p-4 shadow d-flex gap-2 align-items-start position-relative">
                  <div>
                    <strong>Greetings, FitPro!</strong> At this time, our website doesn't include options for management tasks.
                    Its main function is to provide users a platform to explore and register for classes.
                    For all management-related tasks, kindly use our iOS App, <a href="https://apps.apple.com/us/app/sweatnow/id1198617381" target="_blank" rel="noreferrer">download now</a>.
                  </div>
                <button type="button" onClick={()=>auth.setShowFitproNotice(false)} className="btn btn-close-white" style={{marginTop:'-15px', marginRight: '-15px'}}><span className="mdi mdi-close-circle-outline"></span></button>
                </div>
              </div>
            </div>
          </div>
        </Section>}

        <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
          <div className={"container"}>
            <div className={"row"}>
              <div className={"col-sm-12 col-md-12 col-lg-4 mb-2"}>
                <Link to={`${AppRoutes.searchEvents.path}?type=${SearchTypes.discover}`} className="router-link">
                  <div className="card text-white border rounded-4 bg-cover clickable hover-cell-effect"
                       style={{height: '320px', backgroundImage: 'url(/assets/images/app/FindYourClass-Back@2x.png)'}}>
                    <div className="card-img-overlay position-relative p-4">
                      <h5 className="card-title"> Find your event, class or clinic</h5>
                    </div>
                    <img className="position-absolute" style={{right: 0, bottom: '-40px'}}
                         src="/assets/images/app/FindYourClass-Char@2x.png" alt=""/>
                  </div>
                </Link>
              </div>
              <div className={"col-sm-12 col-md-6 col-lg-4 mb-2"}>
                <Link to={`${AppRoutes.searchTrainers.path}`} className="router-link">
                  <div className="card text-white border rounded-4 bg-cover clickable hover-cell-effect"
                       style={{
                         height: '320px',
                         backgroundImage: 'url(/assets/images/app/FindYourInstructor-Back@2x.png)'
                       }}>
                    <div className="card-img-overlay position-relative p-4">
                      <h5 className="card-title">Find your FitPros</h5>
                    </div>
                    <img className="position-absolute w-50" style={{right: 0, bottom: '-40px'}}
                         src="/assets/images/app/FindYourInstructor-Char@2x.png" alt=""/>
                  </div>
                </Link>
              </div>
              <div className={"col-sm-12 col-md-6 col-lg-4 mb-2"}>
                <Link to={`${AppRoutes.searchEvents.path}?type=${SearchTypes.popup}`} className="router-link">
                  <div className="card text-white border rounded-4 bg-cover clickable hover-cell-effect"
                       style={{height: '320px', backgroundImage: 'url(/assets/images/app/PopupClasses-back@2x.png)'}}>
                    <div className="card-img-overlay position-relative p-4">
                      <h5 className="card-title">Pop-up classes, events or clinics</h5>
                    </div>
                    <img className="position-absolute w-50" style={{right: 0, bottom: '-40px'}}
                         src="/assets/images/app/PopupClasses-Char@2x.png" alt=""/>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </Section>

        <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
          <div className={"container"}>
            <div className={"row"}>
              <div className={"col-sm-12 col-md-12 mb-2"}>
                <Link to={AppRoutes.eventCategories.path} className="text-decoration-none">
                  <div className="card text-white border rounded-3 bg-cover clickable hover-cell-effect flex-row d-flex justify-content-between align-items-center px-4"
                       style={{height: '50px', backgroundImage: 'url(/assets/images/app/LinkCategories.png)'}}>
                    <span>See all events, classes or clinics</span> <span className="mdi mdi-chevron-right"></span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </Section>

        {banners?.length > 0 &&
            <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
              <div className={"container"}>
                <div className={"row"}>
                  <div className={"col-sm-12 col-md-12 mb-2"}>
                    <ClickableSlider {...bannerSliderSettings}>
                      {banners.map(t => <div key={t.id}>
                        <HomepageBannerCell banner={t} />
                      </div>)}
                    </ClickableSlider>
                  </div>
                </div>
              </div>
            </Section>}

        {upcomingClasses?.length > 0 &&
            <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
              <div className={"container"}>
                <div className={"row"}>
                  <h4>Upcoming classes in your area</h4>
                  <Link to={`${AppRoutes.searchEvents.path}?upcoming=true`} className="link-secondary clickable">
                    See All Upcoming Classes<span className="mdi mdi-chevron-right"></span>
                  </Link>
                  <div className={"col-sm-12 col-md-12 mb-2"}>
                    <ClickableSlider {...upcomingClassesSliderSettings}>
                      {upcomingClasses.map(t => <div key={t.id} className={'p-3'}>
                        <EventCell event={t} esid={t.id} link={`${AppRoutes.events.path}/EID`} />
                      </div>)}
                    </ClickableSlider>
                  </div>
                </div>
              </div>
            </Section>}

        {topTrainers?.length > 0 &&
            <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
              <div className={"container"}>
                <div className={"row"}>
                  <h4>Top FitPros</h4>
                  <TopTrainersListModal ref={topTrainersListModal} trainersList={topTrainers} callback={topTrainersListCallback} />
                  <button className="link-secondary clickable d-inline border-0 bg-transparent w-auto text-decoration-underline" onClick={()=>topTrainersListModal.current.openModal()}>See All Top FitPros<span
                      className="mdi mdi-chevron-right"></span></button>
                  <div className={"col-sm-12 col-md-12 my-2"}>
                    <ClickableSlider {...topTrainersSliderSettings}>
                      {topTrainers.map(t => <div key={t.id} className={'p-3'}>
                        <TopTrainerCell trainer={t} />
                      </div>)}
                    </ClickableSlider>
                  </div>
                </div>
              </div>
            </Section>}

        <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
          <div className={"container"}>
            <div className={"row"}>
              <h4>Trending templates</h4>
              <Link className="link-secondary clickable" to={AppRoutes.eventCategories.path}>
                See All Categories<span className="mdi mdi-chevron-right"></span>
              </Link>
              <div className={"col-sm-12 col-md-12 my-2 mt-4"}>
                <div className="row">
                  {trendingTemplates?.length > 0 && trendingTemplates.map(c => <div key={c.id} className="col-sm-6 col-md-4">
                    <CategoryCell category={c} link={`${AppRoutes.searchEvents.path}?type=${SearchTypes.discover}&categories=[CID]`} />
                  </div>)}
                </div>
              </div>
            </div>
          </div>
        </Section>

      </>
  );
}

Discover.getLayout = function getLayout(page) {
  return (
      <MainLayout>
        {page}
      </MainLayout>
  )
}